import { Wrapper } from "../../styles/TotalScore.style";

export const TotalScore = ({ totalScore, totalWeight }: any) => {
  return <Wrapper>{`Total Score = ${totalScore} / ${totalWeight}`}</Wrapper>;
};
